import { sendAncillaryEventToCustomerIO } from '../../../../utilities/customer-io-ancillary-events';

export default ( event, currencyCode, id, name, price, brand, category, variant, position, balance = null, pnrInfo = null ) => {
  // eslint-disable-next-line no-console
  console.log('🔄 UPGRADE Product Impression - Customer.io Integration Started', {
    event,
    id,
    name,
    price,
    brand,
    category,
    balance,
    pnrData: pnrInfo ? 'available' : 'missing',
  });

  sendAncillaryEventToCustomerIO('upgrades', {
    event: 'productImpression',
    ecommerce: {
      currencyCode: currencyCode,
      impressions: [{
        id: id,
        name: name,
        price: price,
        brand: brand,
        category: category,
        variant: variant,
        position: position,
      }],
    },
  }, pnrInfo, {
    ancillaryType: 'upgrades',
    source: 'upgrade-product-impression',
  });

  return balance ? {
    event: event,
    pointsCP: balance,
    ecommerce: {
      currencyCode: currencyCode,
      impressions: [{
        id: id,
        name: name,
        price: price,
        brand: brand,
        category: category,
        variant: variant,
        position: position,
      }],
    },
  } : {
    event: event,
    ecommerce: {
      currencyCode: currencyCode,
      impressions: [{
        id: id,
        name: name,
        price: price,
        brand: brand,
        category: category,
        variant: variant,
        position: position,
      }],
    },
  };
};